import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleToken } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    // The backend redirects here as  /auth/callback#token=...
    // A URL fragment is never sent to a server, so the token stays out of logs.
    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const sessionToken = params.get('token');
    if (sessionToken) {
      window.history.replaceState(null, '', window.location.pathname);
      handleGoogleLogin(sessionToken);
      return;
    }
    navigate('/login', { replace: true });
  }, [location.hash]);

  const handleGoogleLogin = async (sessionToken) => {
    try {
      await loginWithGoogleToken(sessionToken);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Google login failed');
      setTimeout(() => navigate('/login', { replace: true }), 3000);
    }
  };

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
        <div className="text-center bg-white p-8 rounded-none shadow-sm border border-black/5 max-w-md">
          <p className="text-red-600 font-medium mb-2">Login Failed</p>
          <p className="text-sm text-[#5C665F]">{error}</p>
          <p className="text-xs text-[#5C665F] mt-3">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand mx-auto mb-4" />
        <p className="text-[#5C665F] text-sm">Completing Google sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
